import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { CreatingCar, Car } from "../types";
import { uuid } from "short-uuid";

export const defaultCar: Car = {
	id: uuid(),
	name: "",
	price: 0,
	model: undefined,
	manufactureYear: null,
	brand: undefined,
	minPrice: null,
	merchant: null,
	doors: null,
	note: "",
	mileage: null,
	state: null,
	distanceDriven: null,
	photos: [],
	status: "",
	color: null,
	bodyType: undefined,
	seat: null,
	transmission: null,
	fuel: null,
	engineSize: null,
	description: "",
	origin: null,
	isChecked: false,
};

const initialState: CreatingCar = {
	list: [defaultCar],
};

export const creatingCarsSlice = createSlice({
	name: "creatingCars",
	initialState,
	reducers: {
		setListCreatingCar: (state, action) => {
			state.list = action.payload;
		},
		resetListCreatingCar: (state, action) => {
			const car = { ...defaultCar };
			if (action.payload?.id) {
				car.id = action.payload.id;
			}
			if (action.payload?.car) {
				for (const field in action.payload.car as Partial<Car>) {
					(car as any)[field] = action.payload.car[field];
				}
			}
			state.list = [car];
		},
		clearListCreatingCar: (state, action) => {
			state.list = state.list?.map(car => {
				if (car.id === action.payload)
					return { ...defaultCar, id: action.payload };
				return car;
			});
		},
		setMerchantStores: (state, action) => {
			state.stores = action.payload;
		},
	},
});

export const {
	setListCreatingCar,
	resetListCreatingCar,
	clearListCreatingCar,
	setMerchantStores,
} = creatingCarsSlice.actions;

export const selectCarCreatingList = (state: RootState) =>
	state.creatingCars.list ?? [defaultCar];
export const selectMerchantStores = (state: RootState) =>
	state.creatingCars.stores;

export default creatingCarsSlice.reducer;
